import { useTranslations } from '@vocab/react';
import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { OVERALL_EXPERIENCE_MAX_LENGTH } from '../../validation/validationRules';
import translations from './.vocab';

export const OverallExperienceDetailsQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  const { t } = useTranslations(translations);
  return (
    <Textarea
      id="overallExperienceDetails"
      label={t('Tell us about your experience')}
      description={t(
        'Share both the positive and negative aspects of your experience',
      )}
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={OVERALL_EXPERIENCE_MAX_LENGTH}
    />
  );
};
